import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { useAuth } from '@auth/auth-context'

const Logout = () => {
  const { endSession } = useAuth()
  const [isDone, setIsDone] = useState(false)

  useEffect(() => {
    endSession().then(() => setIsDone(true))
  }, [endSession])

  if (isDone) {
    return <Redirect to="/login" />
  }

  return <div>logging out...</div>
}

export default Logout
